/**
 * Transforms number to comma seperated string ("123456789.012" to "123,456,789.012")
 */
const numberToCommaSeparatedString = (number: number): any => {
  if (number) {
    let [ left, right ] = number.toString().split('.')
    left = left.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    return right ? `${left}.${right}` : left
  }

  return number
}

/**
 * Is the number between two values
 * @param {Number} value
 * @param {Array} numberArray
 * @param {Boolean} [inclusive]
 */
const between = (value: number, numberArray: [number, number], inclusive?:boolean): boolean => {
  const min = Math.min(numberArray[0], numberArray[1])
  const max = Math.max(numberArray[0], numberArray[1])

  if (inclusive) {
    return value >= min && value <= max
  }

  return value > min && value < max
}


export default {
  numberToCommaSeparatedString,
  between,
}
